export class CookieHelper {
  public static set = (name: string, value: string, days: number) => {
    const expiresAt = new Date();
    expiresAt.setTime(expiresAt.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value || ''}; expires=${expiresAt.toUTCString()}; path=/`;
  };
}
